import React from "react";
// Import the useDropzone hooks from react-dropzone
import { useDropzone } from "react-dropzone";
import { Box } from "@mui/system";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Typography } from "@mui/material";
import "../examinations/test.css";
import { ColorModeContext } from "../app/App";

const Dropzone = ({ onDrop, accept, file }) => {
  // Initializing useDropzone hooks with options
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple: false,
    maxSize: 2000000,
  });

  const colorMode = React.useContext(ColorModeContext);

  /* 
    useDropzone hooks exposes two functions called getRootProps and getInputProps
    and also exposes isDragActive boolean
  */

  return (
    <div className="dropzone-div" {...getRootProps()}>
      <input className="dropzone-input" {...getInputProps()} />
      {file === null ? (
        <DriveFolderUploadIcon
          className={colorMode === "dark" ? "textClass" : "textClassWhite"}
          sx={{ width: "50%", height: "50%" }}
        />
      ) : (
        <TaskAltIcon sx={{ width: "50%", height: "50%", color: "#90caf9" }} />
      )}
      <Box className="text-center" sx={{ marginBottom: 3 }}>
        {isDragActive ? (
          <Typography
            className="dropzone-content"
            sx={{ color: colorMode === "dark" ? "#c4c4c4" : "#70706f" }}
          >
            Loslassen!
          </Typography>
        ) : (
          <>
            <Typography
              className="dropzone-content"
              sx={{ color: colorMode === "dark" ? "#c4c4c4" : "#70706f" }}
            >
              PDF hierher ziehen oder klicken!
            </Typography>
            <Typography
              className="dropzone-content"
              sx={{ color: colorMode === "dark" ? "#c4c4c4" : "#70706f" }}
            >
              Maximale Dateigröße: 2MB
            </Typography>
          </>
        )}
      </Box>
    </div>
  );
};

export default Dropzone;
